module.exports = __webpack_public_path__ + "static/patriciawork8-50cce6b495c4e88b2287f40e287e3f50.jpg";